<template>
  <section class="caseDetail">
    <header-com/>
    <div v-for='(item,index) in list' :key='index'>
      <div class="banner" v-if='item.composeType == 10' v-for='(data,dataIndex) in item.contentBoList'>
        <img :src="data.pic | formatImgUrl(800,1200,true)"/>
        <div class="banner-content">
          <div class="goods-name">{{ detail.brandNameEn }}</div>
          <div class="goods-service f36">{{ detail.serviceName }}</div>
          <div class="goods-brand f36">{{ detail.name }}</div>
          <div class="f28">难度系数：</div>
          <span class="point">
              <span
                    class="inner"
                    v-for="(item,index) in fullDifficulty"
                    :key="index"
                    :class="index<detail.difficulty ? 'actived' : ''"
                  ></span>
                  {{ detail.difficulty&&detail.difficulty.toFixed(1) }}
              </span>
        </div>
        <div class="block">
          <div class="step_block"></div>
        </div>
      </div>
      <!-- 品牌信息 -->
      <section class="proInfo" v-if="item.composeType == 20" :style="{'backgroundImage':'url('+formatImgUrl(item.contentBoList[0].pic,1200,800,true)+')'}">
        <div class="inner clearfix">
          <div class="pic l">
            <img :src="item.contentBoList[1].pic | formatImgUrl(800,800,true)" align="middle" alt="">
          </div>
          <div class="hGroup bold">
            <p><span>商品名称：</span>{{detail.brandNameEn}}</p>
            <p><span>商品类型：</span>{{detail.categoryName}}</p>
            <p><span >商品材质：</span>{{detail.material}}</p>
            <p><span >商品颜色：</span>{{detail.colorName}}</p>
          </div>
          <h4 class="f28">{{item.contentBoList[1].content}}</h4>
        </div>
      </section>
      <!--鉴定师-->
      <section class="appraise " v-if='item.composeType == 40'>
        <img src="/images/case/case_detail_03.png" align="middle" alt="">
        <img v-for='(data,dataIndex) in item.contentBoList' :src="data.pic | formatImgUrl(800,500,true)" align="middle" alt="">
      </section>
      <!-- <img :src="detail.atmosphereBo&&detail.atmosphereBo[0].image" align="middle"> -->
      <!--图片列表-->
      <section class="imgList" v-if='item.composeType == 50'>
        <div class="t_center">
          <h2 class="bold">奢侈品症状评估</h2>
          <h4 class="f32">精心检测，提供最完善的诊断标准</h4>
        </div>
        <ul>
          <li v-for="(data,dataIndex) in item.contentBoList" :key="dataIndex">
            <img :src="formatImgUrl(data.pic,1200,800,true)" align="middle">
            <div>
              <h3 class="bold f36">{{data.title}}</h3>
              <p class="f26" v-html='data.content'>{{data.content}}</p>
            </div>
          </li>
        </ul>
      </section>
      <!--诊断方案-->
      <section class="diagnostic" v-if='item.composeType == 60 || item.composeType == 70'>
        <div class="t_center" v-if='item.composeType == 60'>
          <img src="/images/case/case_detail_04.png" align="middle">
        </div>
        <p  class="f42" v-if='item.composeType == 60' v-html='item.contentBoList[0].content'>{{item.contentBoList[0].content}}</p>
        <ul v-if='item.composeType == 70'>
          <li v-for="(item, index) in item.contentBoList" :key="index">
            <div>
              <img :src="formatImgUrl(item.pic,500,500,true)" alt="" align="middle">
              <h3>{{item.title}}</h3>
              <p v-html='item.content'>{{item.content}}</p>
            </div>
            <!-- <div>
              <img :src="item.after.image" alt="" align="middle">
              <h3>{{item.after.title}}</h3>
              <p>{{item.after.description}}</p>
            </div> -->
          </li>
        </ul>
      </section>
    </div>
    <div class="tool-bar f28">
        <div style="width:100%">
            <!-- <div  id="alldo" style="float: left;position:absolute;width:160px;z-index:999;height: 50px;">
            </div> -->
                
            <!-- <button class="kefu" @click='submit()'><img src="/images/base/wechart-icon.png" class="icon" alt="">问客服</button> -->
            <button class="kefu2" @click='toPublic'><img src="/images/base/wechart-icon.png" class="icon" alt="">问客服</button>
            
            
            <button class="primary pay" @click='submitR()'>我也要拯</button>
        </div>
    </div>
  </section>
</template>

<script>
  const imgUrl = 'https://img.yzcdn.cn/public_files/2017/09/05/3bd347e44233a868c99cf0fe560232be.jpg'
  import caseApi from "@/axios/case";
  import wxShare from "@/assets/js/wx.share"
  import zhugeObj from '@/assets/js/track'
  import { setTimeout } from 'timers';
  import getWXConfig from "@/assets/js/wx.config";
  export default {
    name: 'caseDetail',
    data () {
      return {
        id : '',
        detail : {},
        list : [],
      }
    },
    watch: {},
    computed: {
      fullDifficulty () {
        return new Array(Math.ceil(this.detail.difficulty || 0))
      }
    },
    created () {
      this.id = this.$route.query.id;
      this.getDetail(this.id);
    },
    mounted () {
      getWXConfig()

      // 屏蔽客服按钮
      // var dom = document.getElementById('alldo') //
      // let urlend = encodeURIComponent(window.location.href)
      // dom.innerHTML = '<wx-open-launch-weapp path="pages/kefu/index.html?h5Url=我正在浏览精选案例['+document.title+']：'+urlend+'" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:160px;height:45px;"></div></template></wx-open-launch-weapp>'
  
      // var launchBtn = document.getElementById('launch-btn')
      // if (!launchBtn) {
      // return
      // }
      // launchBtn.addEventListener('launch', function (e) {
      //   zhugeObj.track({
      //       title: "精选案例详情页-问客服按钮-点击"
      //     });
      //   })
      // launchBtn.addEventListener('error', function (e) {
      // console.log('fail', e.detail)
      // })
    },
    methods: {
      toPublic() {
        window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwNjUzNzQyNA==&scene=124#wechat_redirect'
      },

      submitR(){
        zhugeObj.track({
          title: "精选案例详情页-直接寄包按钮-点击"
        });
        this.$router.push({
          name: "quick"
        });
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      getDetail(id){
        caseApi.classicDetail(id).then((res)=>{
          document.title = res.name + res.serviceName
          this.list = res.composeTypeBoList;
          this.detail = res;

          let shareBody = {
            desc : '打理心爱之物',
            title : '包包焕然一新的神秘之术——包拯',
            imgUrl : this.formatImgUrl(res.showPic,500,500,true)
          }; 

          wxShare(shareBody);

        })
      }

    }

  }
</script>

<style lang="scss" scoped>
.f42{
  font-size:30px;
}
  .caseDetail {
    .banner {
      width: 100%;
      height: 1112px;
      color: $white-color;
      text-indent:40px;
      position: relative;
      /*background: #000;*/
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
      }
      .banner-content {
        width: 100%;
        height: 1112px;
        color: #fff;
        text-indent:40px;
        position: absolute;
        top: 0;
        left: 0;
        .goods-name {
          line-height: 106px;
          font-size: 76px;
          margin:108px 0 20px;
          font-weight: bold;
        }
        .goods-brand, .goods-service {
          line-height: 50px;
        }
        .goods-brand{
          margin-bottom: 42px;
        }
        > span {
          display: block;
        }
        .point {
          display: flex;
          padding: 16px 0 0 40px;
          align-items: center;
          > span {
            margin-right: 4px;
          }
          .inner {
            width: 34px;
            height: 34px;
            background: url("/images/case/case_detail_01.png") no-repeat center;
            background-size: 34px;
          }
          .actived {
            background-image: url("/images/case/case_detail_02.png");
          }
        }
      }
      .block {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background: rgba(255, 255, 255, .3);
        height: 10px;
        /*<!--@include ptr(height, 10);-->*/
        .step_block {
          width: 258px;
          height: 10px;
          background: $white-color;
        }
      }
    }
    /*商品信息*/
    .proInfo {
      color: $white-color;
      background: no-repeat center center;
      background-size: 100%;
      .inner {
        padding: 54px 46px;
        height: 362px;
        background: rgba(0, 0, 0, .7);
        .pic {
          padding: 8px 44px 8px 14px;
          position: relative;
          img {
            width: 192px;
            height: 180px;
          }
          &:after {
            content: "";
            position: absolute;
            right: 20px;
            top: 6px;
            height: 186px;
            border-left: 1px $white-color dotted;
          }
        }
        .hGroup {
          line-height: 34px;
          margin-bottom: 68px;
          height: 200px;
          p {
            margin-bottom: 20px;
          }
        }
      }
      h4 {
        line-height: 40px
      }
    }
    /*鉴定师*/
    .appraise {
      img {
        width: 100%
      }
    }
    .imgList {
      margin-bottom: 68px;
      img {
        width: 100%
      }
      h2 {
        font-size: 48px;
        line-height: 66px;
        padding: 72px 40px 8px;
        
      }
      h4 {
        line-height: 44px;
        margin-bottom: 20px
      }
      li div {
        padding: 16px 40px 72px;
        h3 {
          line-height: 78px;
          height: 78px;
        }
        p {
          line-height: 40px
        }
      }
    }
    /*诊断方案*/
    .diagnostic {
      margin-bottom: 80px;
      > div img {
        width: 238px;
        margin-bottom: 66px
      }
      h3 {
        font-size: 36px;
        line-height: 66px;
        font-weight: bold;
      }
      /*h4{line-height: .17rem;margin-bottom: .33rem}*/
      > p {
        padding: 0 36px 54px;
        
        line-height: 54px
      }
      ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      ul li {
        // display: flex;
        // justify-content: space-between;
        margin-bottom: 40px;
        width: 360px;
        > div {
         
          img {
            width: 100%;
            height: 372px;
            margin-bottom: 26px
          }
          h3, p {
            padding: 0 40px
          }
          p {
            line-height: 34px;
            color:$base-grey;
            /*<!--color: $light-dark;-->*/
            font-size: 26px
          }
        }
      }
    }
  }
  .tool-bar{
      position: fixed;
      width: 100%;
      display: flex;
      z-index: 9;
      align-items: center;
      height: 108px;
      bottom: 0px;
      left: 0;
      background:rgba(255,255,255,1);
      box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
      justify-content: flex-end;
    
      .pay{
          width: 44.2666%;
          height: 84px;
      }
    }
    .kefu,.kefu2{
        width: 44.2666%;
        height: 84px;
        font-size: 30px;
        position: relative;
        top: -2px;
        font-weight: 900;
        margin-left:3.8%;
        margin-right:3.8%;
        box-shadow: 0px 0px 8px 0px rgba(0, 217, 103, 0.1);
        border-radius: 46px;
        border: 2px solid #333333;
        .icon{
            display: inline-block;vertical-align: middle;width: 40px;height: 40px;margin: 10px;
        }
    }
</style>
